import classNames from "classnames";

function TabButton({ onClick, btnText, isActive }) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        {
          "border-b-[2px] text-primary": isActive,
        },
        `py-5 px-2 font-medium text-[0.875rem] lg:text-base whitespace-nowrap cursor-pointer text-grayD3 border-primary hover:text-primary`
      )}
    >
      {btnText}
    </button>
  );
}

export default TabButton;
